module.exports = __webpack_public_path__ + "img/frenchrose_hair.c45e5213.jpg";